import React from 'react';

export default function SimpleBarList({ items, testId }) {
  const max = Math.max(1, ...items.map((i) => i.value || 0));
  return (
    <div className="space-y-2" data-testid={testId}>
      {items.map((i) => (
        <div key={i.label}>
          <div className="mb-1 flex justify-between text-xs text-slate-600">
            <span className="truncate">{i.label}</span>
            <span className="font-bold text-slate-800">{i.value}</span>
          </div>
          <div className="h-2 w-full overflow-hidden rounded-full bg-slate-100">
            <div className="h-full rounded-full bg-teal-500" style={{ width: `${((i.value || 0) / max) * 100}%` }} />
          </div>
        </div>
      ))}
    </div>
  );
}
